import React from "react";
import { ArrowUpRight, ArrowUp } from "lucide-react";
import { scrollLandingToSection, scrollLandingToTop } from "./landingScroll";

const footerNavItems = [
  { label: "Studio", sectionId: "home" },
  { label: "Work", sectionId: "features" },
  { label: "Contact", sectionId: "cta" }
];

export function LandingFooter({ scrollContainerRef }) {
  const year = new Date().getFullYear();

  const handleSectionNav = (event, sectionId) => {
    event.preventDefault();
    scrollLandingToSection(scrollContainerRef?.current, sectionId);
  };

  const handleScrollToTop = () => {
    scrollLandingToTop(scrollContainerRef?.current);
  };

  return (
    <footer className="landing-footer" aria-label="Portal footer">
      <div className="landing-footer__stack">
        <div className="landing-footer__main">
          <div className="landing-footer__branding">
            <p className="landing-footer__copyright">© EU Compliance Suite</p>
            <p className="landing-footer__tagline">By Digital Experience Leaders.</p>
          </div>

          <nav className="landing-footer__social" aria-label="Social links">
            <a
              href="https://www.facebook.com/Theplatformgroupwiesbaden/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Facebook"
            >
              <span aria-hidden="true">f</span>
            </a>
            <span className="landing-footer__social-separator" aria-hidden="true">✶</span>
            <a
              href="https://www.xing.com/pages/theplatformgroup"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit Xing"
            >
              <span aria-hidden="true">x</span>
            </a>
            <span className="landing-footer__social-separator" aria-hidden="true">✶</span>
            <a
              href="https://www.linkedin.com/company/theplatformgroup"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Visit LinkedIn"
            >
              <span aria-hidden="true">in</span>
            </a>
          </nav>

          <nav className="landing-footer__legal" aria-label="Legal links">
            <a href="https://the-platform-group.com/datenschutzerklaerung/" target="_blank" rel="noopener noreferrer">
              Datenschutzerklärung
            </a>
            <a href="https://the-platform-group.com/impressum/" target="_blank" rel="noopener noreferrer">
              Impressum
            </a>
          </nav>

          <p className="landing-footer__meta">EU Compliance Suite · {year}</p>
        </div>

        <div className="landing-footer__extension" aria-label="Footer quick navigation">
          <div className="landing-footer__extension-links">
            {footerNavItems.map((item) => (
              <a
                key={item.label}
                href={`#${item.sectionId}`}
                className="landing-footer__pill"
                onClick={(event) => handleSectionNav(event, item.sectionId)}
              >
                <span>{item.label}</span>
                <ArrowUpRight size={16} />
              </a>
            ))}
          </div>
          <button type="button" className="landing-footer__pill landing-footer__pill--up" onClick={handleScrollToTop}>
            <span>Go up</span>
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
}
